import React from 'react';
import { VictoryChart, VictoryAxis, VictoryTooltip, VictoryLabel, VictoryBar } from 'victory';
import { WithTranslation, withTranslation } from 'react-i18next';
import { MonthlyTransactions } from '../../../customerHelpers';
import { formatMoney } from '../../../../helpers/formatters';
import theme from '../../../../styles/victory-theme';
import styled from 'styled-components/macro';

interface RevenueChartProps extends WithTranslation {
    data: MonthlyTransactions[];
    currency: string;
}

const RevenueChart = (
    {
        data,
        t,
        i18n,
        currency,
    }: RevenueChartProps
) => {
    const tickFormat = data.map((gd) => {
        return `${t(`customers.graph.months.${gd.month + 1}`)}\n${gd.year}`;
    });
    const lng = i18n.language;
    return (
        <VictoryChart domainPadding={14} padding={{ top: 14, bottom: 40, left: 14, right: 94 }} theme={theme}>
            <VictoryAxis
                dependentAxis
                orientation="right"
                offsetX={90}
                tickFormat={(x: number) => formatMoney(i18n.language, x, currency)}
                style={{
                    axis: {
                        strokeWidth: 0,
                    },
                }}
            />
            <VictoryAxis
                tickFormat={tickFormat}
                tickLabelComponent={<CustomTick />}
                style={{
                    grid: {
                        strokeWidth: 0,
                    },
                    axis: {
                        stroke: '#dfdfdf',
                    },
                }}
            />
            <VictoryBar
                labelComponent={<VictoryTooltip theme={theme} />}
                labels={(m: { datum: MonthlyTransactions }) => `${m.datum.numTransactions} ${t('customers.graph.transactions')}\n${formatMoney(lng, m.datum.total, currency)}`}
                data={data}
                x="sort"
                y="total"
                cornerRadius={2}
            />
        </VictoryChart>
    );
};


const CustomTick = styled(VictoryLabel)`
    tspan:first-child {
        font-weight: 700;
    }
`;

export default withTranslation()(RevenueChart);
